'use client'

import { useTranslations } from 'next-intl'

import { Button, Icon } from '@graftcode/design-system'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'
import { AppRoute } from '@common/enums'

import { useLayoutStore } from '@stores/layout/layout.store'

import styles from './BaseLayoutClient.module.scss'

type SidebarSettingsBackProps = {
  onNavigationClick: (path: string) => void
}

export function SidebarSettingsBack({ onNavigationClick }: SidebarSettingsBackProps) {
  const t = useTranslations('core')
  const { sidebarCollapsed } = useLayoutStore()

  return (
    <Button
      data-testid={LAYOUT_TEST_IDS.sidebarSettingsBack}
      size="l"
      variant="ghost"
      fullWidth
      text={sidebarCollapsed ? '' : t('sidebar.settings')}
      icon={Icon.ChevronLeftRegular}
      iconOnly={sidebarCollapsed}
      onClick={() => onNavigationClick(AppRoute.DASHBOARD)}
      className={styles.settingsBackButton}
    />
  )
}
